<div class="container">
  <div style="height: 120px">
    <mat-icon class="graphic" svgIcon="success"></mat-icon>
  </div>
  <div class="page-title">{{'message.submitted' | translate}}</div>
</div>
